module.exports = __webpack_public_path__ + "static/media/PATS_4-634w.a9728732.png";